<template>
  <el-avatar :size="size" :src="resolvedSrc" class="user-avatar" :style="textStyle">
    {{ initial }}
  </el-avatar>
</template>

<script setup>
import { computed } from 'vue'
import Util from '@/utils/util'

const props = defineProps({
  name: { type: String, default: '' },
  headimg: { type: String, default: '' },
  size: { type: [Number, String], default: 32 }
})

const resolvedSrc = computed(() => {
  return props.headimg ? Util.getUrl(props.headimg) : ''
})

const initial = computed(() => {
  const n = (props.name || '学').trim()
  return n ? n.charAt(0) : '学'
})

const textStyle = computed(() => {
  const px = Number(props.size) || 32
  return { fontSize: Math.round(px * 0.42) + 'px' }
})
</script>

<style scoped>
.user-avatar {
  background: var(--el-color-primary-light-7);
  color: #fff;
  font-weight: 500;
}
</style>
